export { default as SimpleDataTable } from './_DataTableController';